import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url, USER_PROFILE_SECTION_PATHS } from '@wix/da-url';
import { PapiUser } from '@wix/da-papi-types';
import EmptyState from '../../EmptyState';
import { WatchedDeviants, Props as WidgetProps } from './WatchedDeviants';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import WatchedDeviantsConfigPopover from './WatchedDeviantsConfigPopover';

import s from './WatchedDeviants.scss';

const WatchedDeviantsBox: React.FC<
  WidgetProps &
    WidgetBoxProps & {
      type: 'watchers' | 'watching';
      totalCount?: number;
      isOwner: boolean;
      profileOwnerUser: PapiUser;
      canSeeAll?: boolean;
    }
> = ({
  type,
  isEmpty,
  isOwner,
  canSeeAll,
  totalCount,
  widgetRemove,
  widgetMoveUp,
  widgetMoveDown,
  widgetMenuRenderer,
  section,
  zone,
  ...props
}) => {
  const { t } = useTranslation();
  const navigateToDyW = () => {
    window.location.replace(Url.browseDeviantsYouWatchLink());
  };
  return (
    <WidgetBox
      section={section}
      zone={zone}
      header={t(`widgets.${type}.header`)}
      count={totalCount}
      seeAllUrl={Url.userLink(
        props.profileOwnerUser.username,
        `${USER_PROFILE_SECTION_PATHS.ABOUT}#${type}`
      )}
      hasMore={props.hasMore && canSeeAll}
      moduleId={props.moduleId}
      widgetMenuRenderer={close => (
        <WatchedDeviantsConfigPopover
          moduleId={props.moduleId}
          onClose={close}
        />
      )}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      isEmpty={isEmpty}
      emptyView={
        isOwner ? (
          <EmptyState
            view="small"
            className={s['empty-state']}
            title={t(`widgets.${type}.empty.title.owner`)}
            subtitle={t(`widgets.${type}.empty.subtitle.owner`)}
            buttonLabel={t(`widgets.${type}.empty.CTALabel.owner`)}
            withButton={true}
            onButtonClick={navigateToDyW}
          />
        ) : null
      }
    >
      <WatchedDeviants {...props} />
    </WidgetBox>
  );
};
WatchedDeviantsBox.displayName = 'WatchedDeviantsBox';

export default WatchedDeviantsBox;
